import React from 'react';
import moment from 'moment';
import CollapsePanelContent, { StopTag } from './CollapsePanelContent'
import ExStockTag from '../product-ex-stock/tag';
import {
    Row,
    Col,
    Button,
    Collapse,
    Icon,
    Tag
} from 'antd'
import BulkyTag from '../orders-v3/tags/bulky';
const { Panel } = Collapse;

const { DELIVERY_MODES_PRETTY } = require('./config');

class CollapsePanels extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render(){

        let deliveryModeNonCamel = DELIVERY_MODES_PRETTY

        return(
                <div>

                    <Col style={{textAlign: 'center',marginTop:'15px'}}>
                        {
                            this.props.deliveryMode != "eezeeSend" &&
                            <Row type="flex" justify="center" align="middle" >
                                <Button 
                                    icon='lock' 
                                    onClick={()=>
                                        this.props.lockAll(this.props.date, this.props.deliveryMode, false)
                                    } 
                                />
                            </Row>
                        }
                        <Row type="flex" justify="center" align="middle" >
                            <Button 
                                icon='right' 
                                onClick={()=>
                                    this.props.toggleAll(this.props.date, this.props.deliveryMode)
                                } 
                                style={{marginRight:'10px'}}
                            />

                                { deliveryModeNonCamel[this.props.deliveryMode] }

                            <Button 
                                icon='check' 
                                onClick={()=>
                                    this.props.selectAll(this.props.date, this.props.deliveryMode)
                                } 
                                style={{marginLeft:'10px'}}
                            />
                        </Row>
                    </Col>

                    <Collapse 
                        style={{
                            marginTop:'10px', 
                            fontSize:'10px'
                        }}
                        activeKey={ this.props.openKeys } 
                        onChange={ (id)=>this.props.onClickPanel(id,this.props.deliveryMode, this.props.date) }
                    >
                        {

                            this.props.locations.map((_location, i)=> {

                                return (
                                    <Panel 
                                        style={this.renderPanelStyle(_location)}
                                        showArrow={false} 
                                        header={(
                                            <Row gutter={8} type="flex" justify="space-between" align="middle">
                                                <Col span={16}>
                                                    <Row justify="end">
                                                        <Col>
                                                            {this.renderHeaderText(_location)}
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    {this.renderPanelExtra(_location)}
                                                </Col>
                                            </Row>
                                        )}
                                        key={_location._id}
                                    >
                                        <CollapsePanelContent
                                            onUpdateRemarksInternal={this.props.onUpdateRemarksInternal}
                                            onUpdateRemarksExternal={this.props.onUpdateRemarksExternal}
                                            location = { _location }
                                        />
                                    </Panel>
        
                                )
                            }
                        )} 
                    </Collapse>


                </div>
        )
    }

    renderHeaderText = ( _location ) => {

        const containsBulkyProduct = _location.products.filter(_p => _p.isBulky).length > 0
        const containsExStockProduct = _location.products.filter(_p => _p.exStock).length > 0

        if( _location.iotLockerBoxBookingId ){
            return (
                <div>
                    {_location.prettyDo}<br/>
                    <strong>{_location.iotDeviceName}:{_location.iotLockerBoxName}</strong>
                </div>
            )
        }

        return (
            <Row type="flex" justify="center" align="middle" gutter={4}>
                <Col>{_location.prettyDo}</Col>
                <Col>{_location.invNum}</Col>
                {containsBulkyProduct && <Col><BulkyTag /></Col>}
                {containsExStockProduct && <Col><ExStockTag width='50px' /></Col>}
            </Row>
        )

    }

    renderPanelStyle = (_location) => {

        let dateScheduled = moment(_location.dateScheduled)
        let maxDeliveryDate = this.generateMaxDeliveryDate(_location)
        let style = {
            fontSize:'12px'
        }

        if(moment(dateScheduled).diff(maxDeliveryDate, 'day') > 0){
            style["border"] = '2px solid #ff7a45'
            style["borderRadius"] = '3px'
        }

        let amountOfBg = []
        let rejected = _location.products.filter(prod=>prod.rejected)
        
        if(_location.colorTags && _location.colorTags.length > 0){
            amountOfBg = amountOfBg.concat( _location.colorTags.sort() )
        }
        if(rejected.length > 0){
            amountOfBg.push("#ffa39e")
        }
        if(_location.dateCompleted){
            amountOfBg.push("#95de64")
        }
        if(_location.plannedForRoute){
            amountOfBg.push("#69c0ff")
        }

        let container = ""
        let percentage = 5

        for ( let i = 0 ; i <= amountOfBg.length ; i++ ){
            if( i != amountOfBg.length  ){
                container = `${container} ${amountOfBg[i]} ${(i*percentage)}%, ${amountOfBg[i]} ${percentage + (i*percentage)}%,`
            }else{
                container = `${container} #ffff ${(i*percentage)}%, #ffff ${100}%`
            }
        }
       
        style["background"] = `linear-gradient(to right, ${container})`
        
        return (style)
        
    }

    renderPanelExtra = (_location) => {

        return (
            <Row type="flex" justify="space-around" align="middle">
                <Col>
                    {   
                        !this.props.zoneRules[moment(this.props.date).format('ddd')].includes(_location.address.zone) && 
                        _location.orderType != "Enterprise" && 

                        <Icon 
                            type="exclamation-circle" 
                            theme="twoTone" 
                            twoToneColor="#eb2f96" 
                            style={{marginRight:'5px'}}
                        />
                    }
                    {_location.orderType === "Enterprise" && <Icon type="bank" theme="twoTone" twoToneColor="#eb2f96" style={{marginRight:'5px'}}/>}
                </Col>
                <Col>
                    {_location.locationActionRequired === "pickup" && <StopTag location={_location} color="magenta">P</StopTag>}
                    { _location.locationActionRequired === "delivery" && <StopTag location={_location} color="green">D</StopTag> }
                    { _location.locationActionRequired === "recieve" && <Tag color="red">R</Tag> }
                </Col>
                <Col>
                    {
                        <Button 
                            size='small' 
                            shape="circle" 
                            disabled={_location.dateCompleted} 
                            onClick={(e)=>this.props.onSelectHandler(_location , _location._id, e)} 
                            type={this.props.selectedLocations.includes(_location._id) ? "primary" : "default"}>
                                <Icon type="check" />
                        </Button>
                    }
                </Col>
            </Row>
        )
    }

    renderDatePromised = (_location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }
        let numOfWorkingDays = 0
        let promisedDate = moment(_location.datePurchased, 'DD/MM/YY')
        while(numOfWorkingDays < workingDays[_location.deliveryOption]){
            let day = moment(promisedDate).add(1,'day').format('ddd')
            promisedDate = moment(promisedDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }

        return(
            <Row style={{borderBottom:'0.5px solid #d9d9d9', paddingTop:'10px'}} span={4}>
                Promised Delivery Date: <b>{moment(promisedDate).format('DD/MM/YY')}</b>
            </Row>
        )
    }

    generateMaxDeliveryDate = (_location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }

        let maxDeliveryDate = moment(_location.datePurchased, 'DD/MM/YY')
        let numOfWorkingDays = 0
       
        while(numOfWorkingDays < workingDays[_location.deliveryOption]){
            let day = moment(maxDeliveryDate).add(1,'day').format('ddd')
            maxDeliveryDate = moment(maxDeliveryDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }
        return(maxDeliveryDate)
    }

    shouldComponentUpdate(nextProps, nextState){

        return true

        // //check for any changes in tick selections
        // let currentSelections = this.props.selectedLocations
        // let incomingSelections = nextProps.selectedLocations
        
        // if( currentSelections.sort().join() != incomingSelections.sort().join() ){
        //     return true
        // }

        // //check for toggle of optimizedRoute sort
        // if( nextProps.toggleOptimizedRouteMode != this.props.toggleOptimizedRouteMode ){
        //     return true
        // }

        // //check if any changes in opening of panels
        // let currentOpenKeys = this.props.openKeys.sort()
        // let incomingOpenKeys = nextProps.openKeys.sort()

        // if(currentOpenKeys.sort().join() != incomingOpenKeys.sort().join()){
        //     return true
        // }
        
        // //check if toggle of show weekend is toggled
        // if(nextProps.toggleShowWeekend != this.props.toggleShowWeekend){
        //     return true
        // }

        // //check for any changes in locations per date
        // let currentLocations = this.props.locations.filter(_loc=>_loc._id)
        // let incomingLocations = nextProps.locations.filter(_loc=>_loc._id)

        // if( currentLocations.sort().join() != incomingLocations.sort().join() ){
        //     return true
        // }
                
        // //check for dateCompleted, plannedForRoute, rejection of products
        // let currentDateCompleted = []
        // let incomingDateCompleted = []

        // let currentPlannedForRoute = []
        // let incomingPlannedForRoute = []

        // let currentRejected = []
        // let incomingRejected = []

        // let currentColorTags = []
        // let incomingColorTags = []

        // this.props.locations.map(_location=>{

        //     let id = _location._id

        //     if(_location.dateCompleted){
        //         currentDateCompleted.push(id)
        //     }
        //     if(_location.plannedForRoute){
        //         currentPlannedForRoute.push(id)
        //     }

        //     currentColorTags = currentColorTags.concat(_location.colorTags)

        //     _location.products.forEach(_product=>{
        //         if(_product.rejected){
        //             currentRejected.push(_product.productOrderStatusId)
        //         }
        //     })

        // })
        // nextProps.locations.map(_location=>{

        //     let id = _location._id

        //     if(_location.dateCompleted){
        //         incomingDateCompleted.push(id)
        //     }
        //     if(_location.plannedForRoute){
        //         incomingPlannedForRoute.push(id)
        //     }

        //     incomingColorTags = incomingColorTags.concat(_location.colorTags)

        //     _location.products.forEach(_product=>{
        //         if(_product.rejected){
        //             incomingRejected.push(_product.productOrderStatusId)
        //         }
        //     })

        // })

        // if( currentColorTags.sort().join() != incomingColorTags.sort().join() ){
        //     return true
        // }

        // if( currentDateCompleted.sort().join() != incomingDateCompleted.sort().join() ){
        //     return true
        // }

        // if( currentPlannedForRoute.sort().join() != incomingPlannedForRoute.sort().join() ){
        //     return true
        // }
        // if( currentRejected.sort().join() != incomingRejected.sort().join() ){
        //     return true
        // }


        // return false

    }

}
export default CollapsePanels;


// WEBPACK FOOTER //
// ./src/components/delivery-page/CollapsePanels.js